import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import api from '../services/api';
import {
  Box,
  TextField,
  Button,
  Alert,
  Paper
} from '@mui/material';
import { KeySquare } from 'lucide-react';
import Lottie from "lottie-react";
import animation from "./background.json";


function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await api.post('/login', { email, password });
      login(res.data.access_token);
      navigate('/');
    } catch (err) {
      setError('Invalid email or password');
    }
  };

  return (
    
    
<Box
  sx={{
    position: "relative",
    minHeight: "100vh",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    p: 2,
    overflow: "hidden",
  }}
>

  <Box
  sx={{
    position: "absolute",
    inset: 0,
    zIndex: 0,
    overflow: "hidden",

    "& > div": {
      position: "absolute !important",
      top: "50%",
      left: "50%",
      transform: "translate(-50%, -50%)",
      width: "max(100vw, 177.78vh)",
      height: "max(100vh, 56.25vw)",
      pointerEvents: "none",
    },
  }}
>
  <Lottie
  animationData={animation}
  loop
  autoplay
  style={{
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%) scale(1.05)"
  }}
/>
</Box>

  {/* camada branca translúcida */}
  <Box
    sx={{
      position: "absolute",
      inset: 0,
      backgroundColor: "rgba(255,255,255,0.9)",
      zIndex: 1
    }}
  />

  {/* Conteúdo */}
  <Paper
    elevation={6}
    sx={{
      position: "relative",
      zIndex: 2,
      overflow: "hidden",
      backgroundColor: "rgba(255, 255, 255, 0.83)",
      borderRadius: 4,
      boxShadow: "0 8px 32px rgba(0, 0, 0, 0.2)",
      backdropFilter: "blur(10px)",
      WebkitBackdropFilter: "blur(10px)",
      px: 2,
      py: 2,
      maxWidth: 400,
      width: "100%",
      textAlign: "center",

      "&::before": {
        content: '""',
        position: "absolute",
        top: 0,
        left: 0,
        width: "4px",
        height: "100%",
        background: "linear-gradient(180deg, #ec4899, #a855f7)",
        borderTopLeftRadius: 16,
        borderBottomLeftRadius: 16,
      },
    }}
  >

        <Box mb='1' >
        <img
        src="/logo.png"
        alt="Logo"
        style={{ width: 80, height: 80, marginLeft: 8 }}
        />
        </Box>

        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}

        <Box component="form" onSubmit={handleLogin}>
          <TextField
            label="Email"
            type="email"
            fullWidth
            margin="normal"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <TextField
            label="Password"
            type="password"
            fullWidth
            margin="normal"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <Button
            type="submit"
            fullWidth
            sx={{
              mt: 3,
              py: 1.2,
              fontWeight: 'bold',
              color: '#fff',
              background: 'linear-gradient(to right, #ff5252, #ff1744)',
              '&:hover': {
                background: 'linear-gradient(to right, #d50000, #c51162)',
              },
            }}
          >
            <KeySquare size={18} style={{ marginRight: 8 }}/>
            Login
          </Button>
        </Box>
      </Paper>
    </Box>
  );
}

export default Login;
